import { useQuery, UseQueryResult } from 'react-query';
import api from '../../utils/api/api';
import { API_DISCORD_ROLES_ADMIN } from '../../utils/api/constants';
import { DiscordRole } from '../../types/DiscordRole';

export const fetchDiscordRoles = async (): Promise<DiscordRole[]> => {
  return api.get(API_DISCORD_ROLES_ADMIN).then(res => res.data);
};

export const useDiscordRoles = (): UseQueryResult<DiscordRole[], Error> => {
  return useQuery('adminDiscordRoles', fetchDiscordRoles);
};
